import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.to-string.js";
import i18n from 'i18n';
import { useEffect } from 'react';
import useForm from 'hooks/useForm';
import sortBy from 'utils/sortBy';
import { getCommonAudience } from 'components/FormFields/utils';
function sortDomains(domains) {
  return sortBy(sortBy(domains.map(function (domain) {
    return {
      domainId: domain.id,
      playlistId: domain.playlist_id
    };
  }), function (item) {
    return item.domainId;
  }), function (item) {
    return item.playlistId;
  });
}
function checkWereDomainsChanged(defaultValue, newValue) {
  return JSON.stringify(sortDomains(defaultValue)) !== JSON.stringify(sortDomains(newValue));
}
export default function usePlaylistAccessForm(_ref) {
  var hasOwningTeamError = _ref.hasOwningTeamError,
    accessData = _ref.accessData;
  var playlistAccessForm = useForm({
    fields: {
      /**
       * Domains to which a playlist is shared
       */
      domains: {
        getDefaultValue: function getDefaultValue() {
          return accessData === null || accessData === void 0 ? void 0 : accessData.map(function (ad) {
            return ad.domains;
          }).flat();
        },
        getWasChanged: checkWereDomainsChanged
      },
      /**
       * Playlist audience (actual)
       */
      audience: {
        getDefaultValue: function getDefaultValue() {
          return getCommonAudience(accessData === null || accessData === void 0 ? void 0 : accessData.map(function (ad) {
            return ad.audience;
          }));
        }
      },
      /**
       * Playlist owning team
       */
      ownerTeamIds: {
        getDefaultValue: function getDefaultValue() {
          return accessData === null || accessData === void 0 ? void 0 : accessData.map(function (ad) {
            return ad.ownerTeamId || null;
          });
        },
        getError: function getError(ownerTeamIds) {
          if (hasOwningTeamError) {
            return i18n.t('alert_missing_owning_team_in_playlist_audience', {
              count: ownerTeamIds.length
            });
          }
        }
      },
      /**
       * Allow member contributions
       */
      allow_member_contributions: {
        getDefaultValue: function getDefaultValue() {
          var _allowMemberContribut;
          var allowMemberContributions = accessData === null || accessData === void 0 ? void 0 : accessData.map(function (ad) {
            return ad.allow_member_contributions;
          });
          return (_allowMemberContribut = allowMemberContributions === null || allowMemberContributions === void 0 ? void 0 : allowMemberContributions.every(Boolean)) !== null && _allowMemberContribut !== void 0 ? _allowMemberContribut : false;
        }
      }
    }
  });
  var reset = playlistAccessForm.reset;
  useEffect(function () {
    if (accessData) {
      reset({
        keepUserValues: true
      });
    }
  }, [accessData, reset]);
  return playlistAccessForm;
}